import {
    terms
} from '../terms';


// Called by templates to decrease redundancy
function getVueOptions (name) {
    const opt = {
        name: name,
        data () {
            return {
                errored: false,
                loaded: false,
                person: {},
                terms: terms,
            };
        },
        created () {
            this.getProfileData();
        },
        computed: {
            lang () {
                const defaultLang = this.terms.en;
                const useLang = this.terms[this.person.lang];

                // overwrite non-set fields with default lang
                Object.keys(defaultLang)
                    .filter(k => !useLang[k])
                    .forEach(k => {
                        console.log(k);
                        useLang[k] = defaultLang[k];
                    });

                return useLang;
            },

            contactLinks() {
                const links = {};

                if(this.person.contact.github) {
                    links.github = `https://github.com/${this.person.contact.github}`;
                }

                if(this.person.contact.codefights) {
                    links.codefights = `https://codefights.com/profile/${this.person.contact.codefights}`;
                }

                if(this.person.contact.medium) {
                    links.medium = `https://medium.com/@${this.person.contact.medium}`;
                }

                if(this.person.contact.email) {
                    links.email = `mailto:${this.person.contact.email}`;
                }

                if(this.person.contact.linkedin) {
                    links.linkedin = `https://linkedin.com/in/${this.person.contact.linkedin}`;
                }

                if(this.person.contact.phone) {
                    links.phone = `tel:${this.person.contact.phone}`;
                }

                return links;
            },
        },
        methods: {
            async getProfileData () {
                const headers = JSON.parse(decodeURIComponent(escape(atob(location.search.split('?')[1]))));

                try {
                    const response = await fetch(`https://${process.env.VUE_APP_API_HOST || 'api.emploi.global'}/api/profile/generator_link`, { headers });
                    const json = await response.json();

                    if (response.status >= 200 && response.status < 300) {
                        this.loaded = true;
                        this.person = json.data;
                    } else {
                        const error = new Error(response.statusText);
                        error.response = response;
                        throw error;
                    }
                } catch (error) {
                    this.errored = true;
                    console.log('fetch error', error);
                }
            }
        }
    };
    return opt;
}

export {
    getVueOptions
};
